export const HOMEPAGE_MAX_VISIBLE_SAVED = 6;
export const MINIMUM_PREVIEW_ITEMS = 4;
export const SAVES_PAGE_SIZE = 24;
